export default "__VITE_ASSET__DA2RSJsI__"